import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from './android-chrome-192x192.png';
import dextools from './dextools.png';
import thinkfrog from './thinkerpepe.jpg';
import smartpepe from './smartpepe.jpg';
import uniswap from './uniswap-uni-logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header>
        <div className="header-container">
          <img src={logo} alt="pepe" className="pepelogo" />
          <h1>Pepe's Original Vision</h1>
          <div className="link-container">
            <a href="https://www.dextools.io/app/en/ether/pair-explorer/0x42dd27ff8263ec9e91831fdd25b024f4f2835fd5" className="button"><img src={dextools} width={55} /> </a>
            <a href="https://t.me/pepesoriginalvision" className="button"><FontAwesomeIcon icon={faTelegram} color={"#1A8CD8"} size={"3x"} /></a>
            <a href="https://app.uniswap.org/#/swap?outputCurrency=0xfcec9696d036065fd25d660c6c600445d6ba6b19" className="button"><img src={uniswap} width={55} /></a>
          </div>
        </div>
      </header>
      <main className="content">
        <p className="contract-address">Contract Address: 0xfcEc9696D036065fD25d660C6c600445D6bA6b19</p>
        <div className="content-container">
          <div className="image-1">
            <img src={smartpepe} className="smartfrog" />
            <p style={{ marginTop: "5%" }}>...code, unveiling the truth of $POV. With each word, a burst of enlightenment washed over me, like a tide of brilliant light illuminating the deepest recesses of my mind. Its wisdom radiated with profound harmony, connecting me to the universe in ways..</p>
          </div>
          <div className="tokenomics">
            <h1>
              Tokenomics:
            </h1>
            <p>Total Supply</p>
            <p>690,000,000,000 POV</p>
            <p>4% were kept for dev wallet/marketing</p>
            <p>Rest of supply was added to LP.</p>
            <p>Liquidity locked for 3 months.</p>
          </div>
          <div className="image-2">
            <img src={thinkfrog} className="thinkerfrog" />
            <p style={{ marginTop: "5%" }}>...my ego and id shattered; now a being of pure light, I traverse the boundless cosmos. Reality unfolds in vivid hues, an intricate dance of matter and energy. The benevolent beings from beyond, once distant, now woven into the fabric of existence itself...</p>
          </div>
        </div>
      </main >
      <footer className="footer">
        <div className="socials">
          <a href="https://twitter.com/pepesOGvision">
            <FontAwesomeIcon icon={faTwitter} style={{ marginRight: "5px" }} color={"#1A8CD8"} />
          </a>
          <a href="https://t.me/pepesoriginalvision">
            <FontAwesomeIcon icon={faTelegram} color={"#1A8CD8"} />
          </a>
        </div>
      </footer>
    </div >
  );
}

export default App;
